import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { Menu, X } from 'lucide-react';

const navLinks = [
  { label: 'About', href: '#about' },
  { label: 'Experience', href: '#experience' },
  { label: 'Projects', href: '#projects' },
  { label: 'Coding', href: '#coding' },
  { label: 'Contact', href: '#contact' },
];

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (e, href) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
      setMobileOpen(false);
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-white/80 backdrop-blur-xl border-b border-gray-100/80 shadow-[0_1px_3px_rgba(0,0,0,0.04)]'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 h-[72px] flex items-center justify-between">
        <a href="#about" onClick={(e) => handleNavClick(e, '#about')} className="font-mono text-lg font-medium tracking-tight">
          anurag<span className="text-gray-300">.</span>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={(e) => handleNavClick(e, link.href)}
              className="text-[13px] text-gray-400 hover:text-black transition-colors duration-300 relative group tracking-wide"
            >
              {link.label}
              <span className="absolute -bottom-1 left-0 w-0 h-[0.5px] bg-black transition-all duration-300 group-hover:w-full" />
            </a>
          ))}
          <Button
            onClick={(e) => handleNavClick(e, '#contact')}
            className="ml-2 text-[13px] h-9 px-6 rounded-full bg-[#0a0a0a] text-white hover:bg-[#262626] transition-all duration-300"
          >
            Let's Talk
          </Button>
        </nav>

        <button className="md:hidden p-2 -mr-2" onClick={() => setMobileOpen(!mobileOpen)}>
          {mobileOpen ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>

      <div
        className={`md:hidden overflow-hidden transition-all duration-300 bg-white/95 backdrop-blur-xl ${
          mobileOpen ? 'max-h-80 border-b border-gray-100' : 'max-h-0'
        }`}
      >
        <nav className="flex flex-col px-6 py-4 gap-4">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={(e) => handleNavClick(e, link.href)}
              className="text-sm text-gray-500 hover:text-black transition-colors duration-200"
            >
              {link.label}
            </a>
          ))}
          <Button
            onClick={(e) => handleNavClick(e, '#contact')}
            className="mt-2 text-sm h-10 rounded-full bg-[#0a0a0a] text-white hover:bg-[#262626] w-full"
          >
            Let's Talk
          </Button>
        </nav>
      </div>
    </header>
  );
};

export default Header;
